import BaseDataProcessor from './baseDataProcessor';

export default class MembersDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData) {
    super();

    this.apiStatisticsData = apiStatisticsData;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { total, joined } = this.apiStatisticsData;
      return [
        { primaryText: total, secondaryText: 'members' },
        joined > 0 ? {primaryText: `+${joined}`, secondaryText: 'joined members'} : null
      ].filter(item => item);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/membersDataProcessor.js